module.exports = __webpack_public_path__ + "img/master-plan.87fa5a67.png";